import openApi from '../services/api';

type NewAccountData = {
    name: string;
    email: string;
    password: string;
    recurrence: 'MENSAL';
    dueDate: Date;
    status: 't';
    campaignsEnabled: boolean;
    planId: number;
};

export const register = (newAccountData: NewAccountData): Promise<void> => {
    return openApi.post('/companies/cadastro', newAccountData);
};

export const resetPassword = (email: string): Promise<void> => {
    return openApi.post('/auth/resetPassword', { email });
};

export const confirmToken = (token: string): Promise<void> => {
    return openApi.post('/auth/confirmResetPassword', { token });
};
